(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProgramaEducativoDetailController', ProgramaEducativoDetailController);

    ProgramaEducativoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProgramaEducativo'];

    function ProgramaEducativoDetailController($scope, $rootScope, $stateParams, previousState, entity, ProgramaEducativo) {
        var vm = this;

        vm.programaEducativo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:programaEducativoUpdate', function(event, result) {
            vm.programaEducativo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
